import { SET_POPUP_NOTIFICATION, SET_TOAST_NOTIFICATION } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export interface ToastNotificationState {
    message: string | null
    type: "info" | "success" | "warning" | "default" | "error";
    show?: boolean;
}

// Define an initial state value for the app
const initialState: ToastNotificationState = {
    message: null,
    type: "default"
}
  
export function toastNotificationReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case SET_TOAST_NOTIFICATION: {
            const payloadData = (payload as Record<string, Record<string, unknown>>).data;
            return {
                ...state,
                message: payloadData.message as ToastNotificationState["message"],
                type: payloadData.type as ToastNotificationState["type"]
            }
        }
        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

const initialPopupState: ToastNotificationState = {
    message: null,
    type: "default",
    show: false,
}

export function popUpNotificationReducer(state = initialPopupState, action: AppAction){
    
    const { payload } = action;

    switch (action.type) {
        case SET_POPUP_NOTIFICATION: {
            const payloadData = (payload as Record<string, Record<string, unknown>>).data;
            return {
                ...state,
                message: payloadData.message as ToastNotificationState["message"],
                type: payloadData.type as ToastNotificationState["type"],
                show: payloadData.show as ToastNotificationState["show"]
            }
        }
        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}
